import { defineStore } from 'pinia';

interface I18nState {
  locale: dpost.i18n.language;
  fallbackLocale: dpost.i18n.language;
}

export const useI18nStore = defineStore('i18n', {
  state: (): I18nState => ({
    locale: 'ko',
    fallbackLocale: 'ko',
  }),

  actions: {
    updateLocale(payload: dpost.i18n.language) {
      this.locale = payload;
    },
    updateFallbackLocale(payload: dpost.i18n.language) {
      this.fallbackLocale = payload;
    },
  },
});
